import React from "react";
import type { TFunction } from "i18next";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { ErpId, ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import { type DocumentResource, DocumentTypes } from "@exonn/js-sdk";

export const routePaths = createModuleRoutePaths({
  resource: ResourceEnum.Document,
});

export const module: Module<DocumentResource> = {
  id: ResourceEnum.Document,

  bigIcon: <span className={"icon-20-documents"} />,
  smallIcon: <span className={"icon-15-documents"} />,
  name: (t: TFunction) => t("moduleName.documents"),
  list: {
    filter: ({ clientConfig, user }) => {
      if (
        [ErpId.Kaufbei, ErpId.Stage].includes(clientConfig.erpId) &&
        user?.user_type !== "developer"
      ) {
        return {
          items: [
            {
              field: "document_type",
              operator: "exact",
              value: [DocumentTypes.PaymentReminder, DocumentTypes.Reminder],
            },
          ],
        };
      }
    },
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.document_number,
    },
  },
  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    texts: {
      title: (t) => t("formTabs.texts.title"),
    },
    addresses: {
      title: (t) => t("formTabs.addresses.title"),
    },
  },
};
